'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.enrichmentDataComponent = exports.embedDataComponent = exports.textComponent = exports.imageComponent = exports.adVariant = exports.component = undefined;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _objects = require('./objects');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// --- Component ---

// https://github.schibsted.io/smp-distribution/format/blob/master/iris/v4/article/components.md#components
var component = exports.component = _propTypes2.default.shape({
    type: _propTypes2.default.string.isRequired,
    subtype: _propTypes2.default.string
});

// --- Ad variant ---

// https://github.schibsted.io/smp-distribution/format/blob/master/iris/v4/article/components.md#ad-variant
var adVariant = exports.adVariant = _propTypes2.default.shape({
    alias: _propTypes2.default.string.isRequired,
    probableWidth: _propTypes2.default.number.isRequired,
    probableHeight: _propTypes2.default.number.isRequired,
    minDisplayWidth: _propTypes2.default.number.isRequired
});

// --- Image ---

// https://github.schibsted.io/smp-distribution/format/blob/master/iris/v4/article/components.md#image
var imageComponent = exports.imageComponent = _propTypes2.default.shape({
    byline: _objects.originator,
    caption: _objects.caption,
    imageAsset: _objects.imageAsset.isRequired,
    placement: _propTypes2.default.oneOf(['aside'])
});

// --- Text ---

// https://github.schibsted.io/smp-distribution/format/blob/master/iris/v4/article/components.md#text-component
var textComponent = exports.textComponent = _propTypes2.default.shape({
    type: _propTypes2.default.oneOf(['text']).isRequired,
    subtype: _propTypes2.default.string,
    text: _objects.text
});

// --- Embed ---

// https://github.schibsted.io/smp-distribution/format/blob/master/iris/v4/article/components.md#embed-data-ab
var embedDataComponent = exports.embedDataComponent = _propTypes2.default.shape({
    html: _propTypes2.default.string,
    iframeUrl: _propTypes2.default.string
});

// --- Data ---

// https://github.schibsted.io/smp-distribution/format/blob/master/iris/v4/article/components.md#enrichment-data
var enrichmentDataComponent = exports.enrichmentDataComponent = _propTypes2.default.shape({
    type: _propTypes2.default.string,
    source: _propTypes2.default.string,
    embedDataComponent: embedDataComponent
});
//# sourceMappingURL=components.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/video-asset/~/@spp/iris-prop-types/lib/cjs/components.js
 ** module id = 709
 ** module chunks = 1
 **/